const state = {
  tabsErrors: [],
};

const getters = {};

const actions = {
  setError({ commit }, payload) {
    commit('setError', payload);
  },
  removeError({ commit }, payload) {
    commit('removeError', payload);
  },
};

const mutations = {
  setError(state, error) {
    const index = state.tabsErrors.indexOf(error);
    if (index === -1) {
      state.tabsErrors.push(error);
    }
  },
  removeError(state, error) {
    const index = state.tabsErrors.indexOf(error);
    if (index > -1) {
      state.tabsErrors.splice(index, 1);
    }
  },
  removeErrors(state, errors = []) {
    state.tabsErrors = state.tabsErrors.filter(name => !errors.includes(name));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
